<template>
    <div class="common_container">
        <el-form label-width="90px" :rules="rules" :model="form" ref="form">
            <el-form-item label="用户名" prop="userid" >
                <el-input v-model="form.userid" :disabled="useridEdit" class="form-input"></el-input>&nbsp;
                <span v-show="!useridEdit" style="color:blue;">一旦确定后不可更改</span>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="密码" >
                <el-input v-model="form.password" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="中文名" prop="name">
                <el-input v-model="form.name" class="form-input"></el-input>
            </el-form-item>
            <!--<el-row >-->
                <!--<el-form-item label="别名">-->
                    <!--<el-input></el-input>-->
                <!--</el-form-item>-->
            <!--</el-row>-->
            <el-form-item label="性别" prop="gender">
                <el-radio v-model="form.gender" label="1">男</el-radio>
                <el-radio v-model="form.gender" label="2">女</el-radio>
            </el-form-item>
            <el-form-item label="工号">
                <el-input v-model="form.employeeNo" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="form.mobile" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="enable" >
                <el-radio v-model="form.enable" label="0" :disabled="isEnabled">停用</el-radio>
                <el-radio v-model="form.enable" label="1" :disabled="isEnabled">启用</el-radio>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit">保存</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {getRules} from "./system.rules";
    import services from './system.service'
    const rules=getRules()
    export default {
        name: "thirdPartyUserAdd",
        props:{
          type:{
              type:String,
              default:'add'
          },
            userid:String,
            callback:Function,
        },
        data(){
            return{
                formName:"form",
                rules: rules,
                form:{
                    email:'',
                    mobile:'',
                    password:'',
                    userid:'',
                    name:'',
                    gender:'',
                    employeeNo:'',
                    enable:'',
                },
                useridEdit:false,
                isEnabled:false,
            }
        },
        created(){
            if (this.type=='edit'){
                this.getDetail()
                this.useridEdit=true
            }else{
                this.form.enable='1'
                this.isEnabled=true
            }
        },
        methods:{
            submit(){
                let formName=this.formName
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.type=='edit'){
                            this.update(this.form)
                        } else{
                            this.add(this.form)
                        }

                    }
                })
            },
            add(params){
                if(!this.form.password){
                    this.$message.error('密码不能为空')
                }else{
                    services.addThirdPartyUser(params).then(res=>{
                        this.$message.success("第三方用户新增成功");
                        this.close(true);
                    }).catch(err=>{
                        this.$message.error(err.message)
                    })
                }


            },
            update(params){
                services.updateThirdPartyUser(params).then(res=>{
                    this.$message.success("第三方用户编辑成功");
                    this.close(true);
                }).catch(err=>{
                    this.$message.error(err.message)
                })
            },
            getDetail(){
                services.getThirdPartyUserDetail({userid:this.userid}).then(res=>{
                  this.form=res
                    this.form={
                      ...this.form,
                        gender:this.form.gender+'',
                        enable:this.form.enable+'',
                    }
                })
            },
            //取消按钮
            onCancel(){
                this.close();
            },
            //取消后关闭页面
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        }
    }
</script>


